<template>
<div>
	<div v-if="!video.video"  class="box_aqa">
		<h3>很抱歉，您查看的视频找不到了！</h3>
		<div class="aqa_zi">
			<p>您可以:</p>
			<div>1.检查刚才的输入</div>
			<div>2.去其他地方逛逛：<span class="lan" @click="xin.goUrl('/index')">首页</span></div>
		</div>
	</div>
	<div v-else class="msg_box">
		<div class="arrow_box clearfloat">
			<span class="arrow_ywz">您的位置：</span>
			<div class="arrow">
				<span class="to" @click="xin.goUrl('/index')">首页</span>
				<span class="el-icon-arrow-right"></span>
				<span class="to" @click="xin.goUrl('/explain')">技术支持</span>
				<span class="el-icon-arrow-right"></span>
				<span class="to" @click="xin.goUrl('/video')">产品操作视频</span>
				<span class="el-icon-arrow-right"></span>
				<span class="topc">视频详情</span>
			</div>
		</div>
		<div >
			<p class="video_title">
				{{video.title}}
			</p>
			<video class="video" controls :src="video.video">
				<h1>您的浏览器不支持 video 标签。</h1>
			</video>
			<div class="vhtml" v-html="video.content">

			</div>
		</div>
	</div>
</div>
</template>

<script>
export default{
	data(){
		return {
			isval:false,
			video:{}
		}
	},
	created(){
		this.Postvideoinfo(this.$route.params.id);
	},
	watch:{
		$route(val){
			this.Postvideoinfo(val.params.id);
		}
	},
	methods:{
		async Postvideoinfo(id){
			if(id){
				let {data} = await this.api.Postvideoinfo({id});
				this.video = data;
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.vhtml{
	/deep/img{
		max-width: 100% !important;
		height: auto;
	}
}
.video{
	width: 100%;
}
	.video_title{
		font-size: 20px;
		text-align: center;
		color: #333333;
		line-height: 50px;
	}
</style>
